import { ChangeDetectionStrategy,Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, FormsModule,NgForm } from '@angular/forms';
import { MatButton,MatIconButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatFormField, MatHint,MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';

import { SecretInputToggleComponent } from 'app/shared/components/secret-input-toggle.component';
import { GeneratedImageConfigProperty, GeneratedImageData, GeneratedImageKind } from 'app/shared/graph';
import { AutoTrimDirective } from 'app/shared/utilities/auto-trim.directive';

@Component({
    selector: 'admin-generated-image-config-editor',
    templateUrl: './generated-image-config-editor.component.html',
    styleUrls: ['./generated-image-config-editor.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatFormField, MatLabel, MatInput, FormsModule, MatCheckbox, MatIconButton, MatIcon, MatButton, AutoTrimDirective, SecretInputToggleComponent, MatSuffix, MatHint]
})
export class GeneratedImageConfigEditorComponent {
    public readonly GeneratedImageKind = GeneratedImageKind;

    @Input()
    kind: GeneratedImageKind;
    @Input()
    isDefinition: boolean
    @Input()
    configs: GeneratedImageData;
    @Input()
    mapBoxAccessKey?: string;
    @Output()
    mapBoxAccessKeyChange: EventEmitter<string> = new EventEmitter<string>();

    removeProperty(properties: Array<GeneratedImageConfigProperty>, index: number): void {
        properties.splice(index, 1);
    }

    addProperty(properties: Array<GeneratedImageConfigProperty>): void {
        properties.push({
            name: '',
            value: '',
            isSecret: false
        });
    }
}
